import apiClient from './client';

export interface EmailConfiguration {
  id: number;
  eventType: string;
  recipients: string[];
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateEmailConfigRequest {
  recipients?: string[];
  enabled?: boolean;
}

/**
 * Get all email configurations
 */
export const getEmailConfigurations = async (): Promise<EmailConfiguration[]> => {
  const response = await apiClient.get('/email-config');
  return response.data.configurations;
};

/**
 * Update email configuration for a specific event type
 */
export const updateEmailConfiguration = async (
  eventType: string,
  data: UpdateEmailConfigRequest
): Promise<EmailConfiguration[]> => {
  const response = await apiClient.put(`/email-config/${eventType}`, data);
  return response.data.configurations;
};

/**
 * Set email recipients for a specific event type
 */
export const setEmailRecipients = async (
  eventType: string,
  recipients: string[]
): Promise<void> => {
  await apiClient.post(`/email-config/${eventType}/recipients`, { recipients });
};

/**
 * Toggle email notifications for a specific event type
 */
export const toggleEmailNotifications = async (
  eventType: string,
  enabled: boolean
): Promise<void> => {
  await apiClient.post(`/email-config/${eventType}/toggle`, { enabled });
};

// Event type labels for display
export const eventTypeLabels: Record<string, { title: string; description: string }> = {
  profile_created: {
    title: 'Profile Created',
    description: 'When a new portal candidate creates their profile'
  },
  theology_submitted: {
    title: 'Theological Survey Submitted',
    description: 'When a candidate submits their theological survey'
  },
  references_submitted: {
    title: 'References Submitted',
    description: 'When a candidate submits their references'
  },
  sending_church_submitted: {
    title: 'Sending Church Submitted',
    description: 'When a candidate submits their sending church information'
  },
  prepare_enrich_requested: {
    title: 'Prepare/Enrich Counseling Requested',
    description: 'When a married candidate requests Prepare/Enrich counseling'
  },
  background_check_submitted: {
    title: 'Background Check Submitted',
    description: 'When a candidate submits their background check authorization'
  },
  onboarding_completed: {
    title: 'Onboarding Completed',
    description: 'When a candidate completes all onboarding steps'
  }
};

